import {useAsync} from "react-use";
import {useApiClient} from "./useApiClient";
import React, {useMemo} from "react";
import * as flagIconComponents from 'country-flag-icons/react/3x2';

export interface LanguageOption {
    value: string;
    label: string;
    Flag: flagIconComponents.FlagComponent;
    renderLabel: () => React.ReactNode;
}

function renderLabel(value: string, Flag: flagIconComponents.FlagComponent) {
    return (
        <>
            <div className="w-6 h-4 overflow-hidden rounded shadow-sm">
                <Flag />
            </div>
            <span>{value}</span>
        </>
    );
}

export function useSupportedLanguages() {
    const apiClient = useApiClient();

    const { value: supportedLanguagesConfig = {} } = useAsync(async () => {
        const response = await apiClient.get('supported-languages');

        if (!response.ok) {
            throw new Error('Cannot fetch list of supported languages');
        }

        const data = await response.json() as { supportedLanguages: Record<string, string> };

        return data.supportedLanguages;
    }, []);

    const supportedLanguages: LanguageOption[] = useMemo(() => {
        return Object.entries(supportedLanguagesConfig).map(([code, label]) => {
            const country = code.split('-').pop();
            const Flag = flagIconComponents[country as 'US'];
            const rendered = label ? (label.length <= 17 ? label : code) : code;

            return {
                value: code,
                label,
                Flag,
                renderLabel: () => renderLabel(label, Flag),
                renderSelected: () => renderLabel(rendered, Flag),
            };
        });
    }, [supportedLanguagesConfig]);

    return { supportedLanguages };
}